import { FunctionComponent } from "react";

import { Link, Stack, Text, TooltipHost } from "@bps/fluent-ui";
import { useTenantQuery } from "@libs/api/gateways/plt/plt-gateway.hooks";

interface TenantLinkProps {
  tenantId: string;
}
export const TenantLink: FunctionComponent<TenantLinkProps> = ({
  tenantId
}) => {
  const { data: tenant } = useTenantQuery(tenantId);
  return (
    <TooltipHost
      content={
        <Stack horizontal>
          <Text bold>Application</Text>
          <Text>{tenant?.application}</Text>
        </Stack>
      }
    >
      <Link href={`/tenants/${tenantId}`} target="_blank">
        {tenant?.name}
      </Link>
    </TooltipHost>
  );
};
